const initialState: string[][] = [[], []];
const killedCharReducer = (state = initialState, action: KilledCharType) => {
    switch (action.type) {
        case 'ADD_KILLED_CHAR':
            const idx = action.player - 1;
            let b = state;
            b[idx].push(action.id);
            return b;
        case 'EMPTY_KILLED_CHAR':
            return [[], []];
        default:
            return state;
    }
};

interface KilledCharType {
    type: string;
    id: string;
    player: number;
}
export default killedCharReducer;
